import React, { useState } from 'react';
import RegisterUser from './RegisterUser';
import ForgotPassword from './ForgotPassword';
import '../../css/Login.css';
import '../../css/Form.css';
import ERPUtils from '../../helper/Utils';

const NewUserLogin = (props) => {
	const { LogMeIn, close, setTokenEmployee } = props;

	// used States:
	const [details, setDetails] = useState({
		Email: '',
		password: ''
	});
	const [status, setStatus] = useState({
		login: true,
		forgotPassword: false,
		Register: false
	});
	const [invalidEmail, setInvalidEmail] = useState(false);
	// Required fields:
	const [requiredFields, setRequiredFields] = useState({
		EmailReqError: false,
		PassReqError: false
	});

	// Handlers:
	const onChangeHandler = (event) => {
		event.preventDefault();
		setDetails({
			...details,
			[event.target.name]: event.target.value
		});
		if (ERPUtils.isNullorWhiteSpace(event.target.value) === false) {
			removeRequiredFields(event.target.name);
		}
		if (event.target.name === 'Email' && invalidEmail) {
			setInvalidEmail(false);
		}
	};

	const removeRequiredFields = (name) => {
		const oldData = { ...requiredFields };
		if (name === 'Email') {
			oldData['EmailReqError'] = false;
		}
		if (name === 'password') {
			oldData['PassReqError'] = false;
		}
		setRequiredFields(oldData);
	};

	const StatusHandler = (event) => {
		const val = event
		var newobj = {};
		Object.keys(status).map((el) => {
			if (el === val) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		const convert = { ...newobj };
		setStatus(convert);
		removeAllErrros();
	};

	const removeAllErrros = () => {
		setInvalidEmail(false);
		setRequiredFields({
			EmailReqError: false,
			PassReqError: false
		});
		setDetails({
			Email: '',
			password: ''
		});
	};

	const openLogin = (name) => {
		var newobj = {};
		Object.keys(status).map((el) => {
			if (el === name) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		const convert = { ...newobj };
		setStatus(convert);
	};

	const validateEmail = () => {
		// eslint-disable-next-line
		const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		const validEmail = details.Email === '' ? '' : details.Email.match(EmailCheck);
		if (validEmail !== null) {
			LogMeIn(details.Email, details.password);
		} else {
			setInvalidEmail(true);
		}
	};

	const checkRequired = () => {
		const oldData = { ...requiredFields };
		if (ERPUtils.isNullorWhiteSpace(details.Email)) {
			oldData['EmailReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.password)) {
			oldData['PassReqError'] = true;
		}
		checkForRequiredErrors(oldData);
	};

	const checkForRequiredErrors = (data) => {
		let validationErrorsFound = [];
		Object.keys(data).map((el) => {
			validationErrorsFound.push(data[el]);
			return '';
		});
		if (validationErrorsFound.indexOf(true) !== -1) {
			setRequiredFields(data);
		} else {
			validateEmail();
		}
		return '';
	};

	const showPassWord = () => {
		var temp = document.getElementById('loginPassword');
		if (temp.type === 'password') {
			temp.type = 'text'
			document.getElementById('togglePassword').classList.add('fa-eye-slash')
		}
		else {
			temp.type = 'password'
			document.getElementById('togglePassword').classList.remove('fa-eye-slash')
		}
	}

	return (
		<div>
			<style>
				{`  input::-ms-reveal,
                  input::-ms-clear {
                       display: none;
                 }`}
			</style>
			{status.Register ? <RegisterUser loginHere={StatusHandler} close={close} setTokenEmployee={setTokenEmployee} /> : null}
			{status.login ? (
				<div className="card employee-application-card-style-1">
					<div>
						<form action='none' onSubmit={(e) => { e.preventDefault() }}>
							<div className="formHeader">
								<h2 className="headTypo">
									Login
									<button className="removeButton" type="button" onClick={close}>
										&times;
									</button>
								</h2>
							</div>
							<div className="formBody">
								<div className="form-group has-feedback formWrapper">
									<label className="formlabel">
										Email
									</label>
									<span className="loginsRequiredText">*</span>
									<input
										name="Email"
										type="text"
										className="form-control input"
										onChange={onChangeHandler}
										autoComplete="off"
										placeholder="Email Address"
										value={details.Email}
										onKeyDown={(e) => { if (ERPUtils.isKeyBoardEnterPressed(e)) document.getElementById("loginPassword").focus() }}
										maxLength={200}
									/>
									<span toggle="#password-field" className="far fa-user field-icon" id="userIcon"></span>
									{requiredFields.EmailReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter your email
											address
										</p>
									) : null}
									{invalidEmail ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid email
											Address
										</p>
									) : null}
								</div>
								<div className="form-group has-feedback formWrapper">
									<label className="formlabel">
										Password
									</label>
									<span className="loginsRequiredText">*</span>
									<input
										className="form-control input"
										name="password"
										type="password"
										onChange={onChangeHandler}
										autoComplete="off"
										placeholder="Password"
										value={details.password}
										id="loginPassword"
										onKeyDown={(e) => { if (ERPUtils.isKeyBoardEnterPressed(e)) checkRequired() }}
										maxLength={100}
									/>
									<span toggle="#password-field" className="fa fa-eye field-icon" id="togglePassword" onClick={showPassWord}></span>
									{/* <i  id="togglePassword" onClick={showPassWord}></i> */}
									{requiredFields.PassReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter your password
										</p>
									) : null}
								</div>
							</div>
							<div className="formFooter">
								<div>
									<button className="ContinueButton" name="logged" onClick={checkRequired}>
										Continue
									</button>
								</div>
								<br />
								<span className="span">
									<p
										className="link link-primary emp-appl-custom-link"
										name="forgotPassword"
										onClick={() => StatusHandler("forgotPassword")}
										tabIndex={0}
										onKeyDown={(e) => {
											if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
												StatusHandler("forgotPassword")
										}}
									>
										Forgot Password?
									</p>
								</span>
								<span className="span">
									Don't have an account?&nbsp;
									<span
										className="link link-primary emp-appl-custom-link"
										name="Register"
										onClick={() => StatusHandler("Register")}
										tabIndex={0}
										onKeyDown={(e) => {
											if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
												StatusHandler("Register")
										}}
									>
										Register now
									</span>
								</span>
							</div>
						</form>
					</div>
				</div>
			) : null}
			{status.forgotPassword ? (
				<ForgotPassword loginback={StatusHandler} close={close} openLogin={openLogin} />
			) : null}
		</div>
	);
};
export default NewUserLogin;
